import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {labelBeagleHistoryCard} from "../BeagleHistory/LabelBeagleHistoryCard";


function createNutrientData(nutrientLabel, nutrientNumber) {

    //Placeholder, text, while loading data.
    if (nutrientNumber === '') {
        return {nutrientLabel, nutrientNumber};
    }

    //Return object with data labels.
    nutrientNumber = nutrientNumber.toFixed(1);
    return {nutrientLabel, nutrientNumber};
}


// function preventDefault(event) {
//     event.preventDefault();
// }

const useStyles = makeStyles({
    table: {
        minWidth: 100,
    },
    blah: {
        fontWeight: "lighter",
        fontSize: "larger",
    },
    styleNutrientLabel: {
        fontSize: "larger",
        textAlign: "center",
    },
    styleNutrientNumber: {
        fontWeight: "bold",
        fontSize: "larger",
        textAlign: "right",
    },
});

export default function BeagleBuildCardTable(props) {

    const classes = useStyles();

    const langPref = props.beagleLanguagePreference;
    const labelNutrient = labelBeagleHistoryCard.labelNutrient[langPref];
    const labelRemoval = labelBeagleHistoryCard.labelRemoval[langPref];

    const cropCalculationRows = [];

    if (props.isPlaceholderCard) {
        cropCalculationRows.push(createNutrientData('N', ''));
        cropCalculationRows.push(createNutrientData('P\u2082O\u2085', ''));
        cropCalculationRows.push(createNutrientData('K\u2082O', ''));
        cropCalculationRows.push(createNutrientData('S', ''));
        cropCalculationRows.push(createNutrientData('P', ''));
        cropCalculationRows.push(createNutrientData('K', ''));
    } else {
        cropCalculationRows.push(createNutrientData('N', props.awsCropCalculation.nutrient.n));
        cropCalculationRows.push(createNutrientData('P\u2082O\u2085', props.awsCropCalculation.nutrient.p2o5));
        cropCalculationRows.push(createNutrientData('K\u2082O', props.awsCropCalculation.nutrient.k2o));
        if (props.awsCropCalculation.nutrient.s !== 0) {
            cropCalculationRows.push(createNutrientData('S', props.awsCropCalculation.nutrient.s));
        }
        cropCalculationRows.push(createNutrientData('P', props.awsCropCalculation.nutrient.p));
        cropCalculationRows.push(createNutrientData('K', props.awsCropCalculation.nutrient.k));
    }


    return (
        <Table size="small" className={classes.table}>
            <TableHead>
                <TableRow>
                    <TableCell align="center" className={classes.blah}>{labelNutrient}</TableCell>
                    <TableCell align="right">{labelRemoval}, {props.awsCropCalculation.nutrientUnit}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {cropCalculationRows.map((row) => (
                    <TableRow key={'D' + row.nutrientLabel}>
                        <TableCell align="center" className={classes.styleNutrientLabel}>{row.nutrientLabel}</TableCell>
                        <TableCell className={classes.styleNutrientNumber}>{row.nutrientNumber}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
}
